import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { QueryResult, useQuery } from '@apollo/client'
import { useEnv } from '@/hooks/useEnv'
import getFirstQueryString from '@/utils/getFirstQueryString'
import SHOP_QUERY from '@gql/LiveShopQuery.gql'

interface LiveInfoState {
  broadcastId?: string;
  serviceId?: string;
  shopId?: string;
  shopContext?: QueryResult<any, Partial<{ broadcastId: string }>>;
}

const useLiveInfo = (): LiveInfoState => {
  const router = useRouter()
  const { broadcastId, service } = router?.query || {}
  const _service = getFirstQueryString(service)?.toLocaleUpperCase()
  const _broadcastId = getFirstQueryString(broadcastId)

  const { isLiffReady } = useEnv()
  const shouldSkip = !isLiffReady || !_broadcastId

  const shopContext = useQuery(SHOP_QUERY, {
    variables: { broadcastId: _broadcastId },
    skip: shouldSkip
  })

  return useMemo(
    () => ({
      broadcastId: _broadcastId,
      serviceId: _service,
      shopId: shopContext.data?.shop?.shopId,
      shopContext
    }),
    [_service, _broadcastId, shopContext]
  )
}

export default useLiveInfo
